.body {
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  margin: 0 auto;
  max-width: 1600px;
  padding: var(--pgm-sys-spacing-16) var(--pgm-sys-spacing-6);
  width: 100%;
}

.card {
  background-color: var(--pgm-sys-color-surface-container-low);
  border-radius: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-6);
  max-width: 720px;
  padding: var(--pgm-sys-spacing-10) var(--pgm-sys-spacing-12);
  width: 100%;
}

.header {
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-1);
}

.title {
  color: var(--pgm-sys-color-on-surface);
  margin: 0;
}

.subtitle {
  color: var(--pgm-sys-color-on-surface-variant);
  margin: 0;
}

.form {
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-6);
}

.actions {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: var(--pgm-sys-spacing-4);
  justify-content: space-between;
}

.help {
  color: var(--pgm-sys-color-on-surface-variant);
  margin: 0;
}

.contactLink {
  color: var(--pgm-sys-color-tertiary);
  text-decoration: underline;
}

.eyeToggle {
  color: var(--pgm-sys-color-on-surface-variant);
  cursor: pointer;
}

.submit {
  white-space: nowrap;
}

@media (max-width: 599.98px) {
  .card {
    padding: var(--pgm-sys-spacing-8) var(--pgm-sys-spacing-6);
  }

  .actions {
    align-items: stretch;
    flex-direction: column;
  }

  .submit {
    align-self: stretch;
  }
}
